<template>
  <IconLucideArrowDownUp />
</template>
